import React from 'react'
import PropTypes from 'prop-types'
import { Container, Row, Col, Alert } from 'react-bootstrap'
import qs from 'qs'
import { client } from '../../utils'
import { analytics as endpoints } from '../../api_urls'
import TitleSection from './TitleSection'
import TableSection from './TableSection'
import TimeframeDropdown from './TimeframeDropdown'

const ATRISK = 'atrisk'
const AVERAGE = 'average'
const EXCELLENT = 'excellent'
const ALL = ''

const lookupStudentType = identifier => {
  switch (identifier) {
    case ATRISK:
      return 'atrisk'
    case AVERAGE:
      return 'average'
    case EXCELLENT:
      return 'excellent'
    default:
      return ALL
  }
}

class StudentAnalytics extends React.Component {
  state = {
    loading: true,
    error: false,
    studentFilter: '',
    chapterFilter: '',
    chapterDropdown: [],
    numFilteredStudents: 0,
    numStudents: 0,
    sortedAnalytics: [],
    senderFullName: '',
    courseTitle: '',
    activePage: 1,
    totalPages: 1,
    tableFilter: 'student',
    filterAscending: true,
    showSimulations: false,
  }

  failureMessage = React.createRef()

  // Resolves true once the analytics load, false after the error state shows.
  updateAnalytics = (
    coursenum,
    chapterFilter = '',
    studentFilter = '',
    activePage = 1,
    tableFilter = '',
    filterAscending = true
  ) => {
    let query = qs.stringify({
      page_num: activePage,
      table_filter: tableFilter,
      asc: filterAscending,
    })
    return client
      .get(
        `${endpoints.progress({
          chapterFilter,
          studentType: lookupStudentType(studentFilter),
        })}?${query}`
      )
      .then(resp => {
        this.setState({ loading: false, ...resp.data })
        return true
      })
      .catch(e => {
        console.error(e)
        this.setState({ error: true })
        return false
      })
  }

  // With updateData, returns the reload's promise from updateAnalytics.
  handleStateChange = (data, updateData = false) => {
    if (updateData) {
      return new Promise(resolve => {
        this.setState(data, () => {
          resolve(
            this.updateAnalytics(
              this.props.coursenum,
              this.state.chapterFilter,
              this.state.studentFilter,
              this.state.activePage,
              this.state.tableFilter,
              this.state.filterAscending
            )
          )
        })
      })
    } else {
      this.setState(data)
    }
  }

  componentDidMount() {
    this.setState(
      {
        studentFilter: this.props.initialStudentFilter,
        chapterFilter: this.props.initialChapterFilter,
      },
      () => {
        this.updateAnalytics(
          this.props.coursenum,
          this.state.chapterFilter,
          this.state.studentFilter,
          this.state.activePage,
          this.state.tableFilter,
          this.state.filterAscending
        )
      }
    )
  }

  renderErrorMsg() {
    return (
      <Container>
        <Row>
          <Col xs={24} sm={12} smOffset={6}>
            <Alert
              style={{ maxWidth: '50%' }}
              variant="danger"
              transition={false}
              ref={this.failureMessage}
              tabIndex={-1}
            >
              An error occurred loading the analytics.
            </Alert>
          </Col>
        </Row>
      </Container>
    )
  }

  render() {
    return (
      <div>
        <TitleSection
          studentFilter={this.state.studentFilter}
          chapterFilter={this.state.chapterFilter}
          coursenum={this.props.coursenum}
          senderFullName={this.state.senderFullName}
          courseTitle={this.state.courseTitle}
          numFilteredStudents={this.state.numFilteredStudents}
        />
        <div className="card-myed">
          {this.state.error ? (
            this.renderErrorMsg()
          ) : (
            <TableSection
              numFilteredStudents={this.state.numFilteredStudents}
              numStudents={this.state.numStudents}
              chapterDropdown={this.state.chapterDropdown}
              loading={this.state.loading}
              coursenum={this.props.coursenum}
              handleStateChange={this.handleStateChange}
              analytics={this.state.sortedAnalytics}
              studentFilter={this.state.studentFilter}
              chapterFilter={this.state.chapterFilter}
              activePage={this.state.activePage}
              totalPages={this.state.totalPages}
              tableFilter={this.state.tableFilter}
              filterAscending={this.state.filterAscending}
              showSimulations={this.state.showSimulations}
              failureMessage={this.failureMessage}
            />
          )}
          <TimeframeDropdown coursenum={this.props.coursenum} />
        </div>
      </div>
    )
  }
}

StudentAnalytics.propTypes = {
  coursenum: PropTypes.string.isRequired,
  initialStudentFilter: PropTypes.string,
  initialChapterFilter: PropTypes.string,
}

export default StudentAnalytics
